import { RefObject, useEffect, useRef } from 'react';

export const useClosestScrollContainer = (
    ref: RefObject<HTMLElement | null>,
    options: Options = { includeHidden: false }
) => {
    const scrollContainerRef = useRef<HTMLElement | null>(null);
    useEffect(() => {
        if (ref.current !== null) {
            scrollContainerRef.current = findClosestScrollContainer(ref.current, options);
        }
    }, [ref, options]);
    return scrollContainerRef;
};

// Based on https://stackoverflow.com/a/42543908
const findClosestScrollContainer = (
    element: HTMLElement,
    { includeHidden }: Options
) => {
    const style = window.getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';

    const overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/;

    if (style.position === 'fixed') {
        return document.body;
    }

    const isScrollContainer = (element: HTMLElement) => {

        const style = window.getComputedStyle(element);

        if (excludeStaticParent && style.position === 'static') {
            return false;
        }

        if (overflowRegex.test(style.overflow + style.overflowY + style.overflowX)) {
            return true;
        }
    };

    let currentElement = element;

    while (currentElement.parentElement !== null) {
        currentElement = currentElement.parentElement;
        if (isScrollContainer(currentElement)) {
            return currentElement;
        }
    }

    return document.body;
};

type Options = {
    includeHidden: boolean;
};